import { render, staticRenderFns } from "./ZIcon.vue?vue&type=template&id=54768dc0&scoped=true&"
import script from "./ZIcon.vue?vue&type=script&lang=js&"
export * from "./ZIcon.vue?vue&type=script&lang=js&"
import style0 from "./ZIcon.vue?vue&type=style&index=0&id=54768dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54768dc0",
  null
  
)

export default component.exports